import type { DestinoDeSoporte } from '../types/admin.types';

/**
 * A3: cómo se anuncia la empresa en la que entra modo soporte. Nombra siempre la empresa REAL:
 * si la persona ya no tiene acceso a la suya, se entra a otra y hay que decirlo antes.
 */
export function textoDelDestino(destino: DestinoDeSoporte): string {
  if (destino.esOrigen) return destino.nombre;
  const origen = destino.origen ?? 'su empresa';
  return `${destino.nombre} (ya no tiene acceso a ${origen})`;
}
